import { InputConfig, MapLocationIcon, TItem } from "@cpj-ai/panel-npm-package";
import { AuthAccountProfileEmploymentStatusChoices, useGetCitiesLazyQuery } from "@graphql/generated";
import Title from "@modules/JobInterest/components/Title";

export type InterestedJobsFormData = {
  employmentStatus?: AuthAccountProfileEmploymentStatusChoices | null;
  interestedJobs?: TItem[];
};

export const getInputConfig = (): InputConfig[] => {
  return [
    {
      name: "jobLocationTitle",
      previewSize: 12,
      inputProps: {
        type: "title",
        className: "text-base text-black mt-6",
        label: <Title Icon={MapLocationIcon} title="Job location city:" />,
      },
    },
    {
      name: "jobCity",
      previewSize: 12,
      inputProps: {
        wrapperClassName: "md:pl-8",
        className: "max-w-full sm:w-full lg:w-1/2",
        type: "searcher",
        label: "Please select the cities you would like to work in:",
        useLazyQuery: useGetCitiesLazyQuery,
        dataPath: "common.cities",
        isMulti: true,
        items: [
          {
            node: {
              id: "all",
              name: "All cities",
            },
          },
        ],
        additionalFilters: {
          country: "CA",
        },
      },
    },
  ];
};
